export default {
}



// WEBPACK FOOTER //
// ./src/app/dweller/meeting/resources/components.js